export const SCREENS = {
  FIRST_SCREEN: 1,
  CUSTOMER_INFO: 1,
  INFO: 2,
  SCHEDULED_SERVICES: 3,
  CRITICAL_ITEMS: 4,
  ADVISED_ITEMS: 5,
  OTHER_ITEMS: 6,
  SIGNATURE: 7,
  THANK_YOU: 8,
};
